import React from 'react';

import { BrowserRouter } from 'react-router-dom';

import Sidemodals from 'domains/widgets/sidemodals';

import { ROUTES } from './constants';
import PublicRoutes from './publicRoutes';

const Routes: React.FC = () => {
  return (
    <BrowserRouter basename={ROUTES.DEFAULT}>
      <PublicRoutes />

      <Sidemodals />
    </BrowserRouter>
  );
};

export default Routes;
